import {
  withDatasourceCheck,
  Placeholder,
  RichText,
  Field,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { useState, useEffect, useCallback, MouseEvent } from 'react';
import eventBus from '../../../hooks/eventBus';
import Checkbox from 'components/Generic/Checkbox';

type GatedAccordionFields = {
  checkboxHint: Field<string>;
  notificationTitle: Field<string>;
  notificationText: Field<string>;
  checkboxText: Field<string>;
};

type GatedAccordionContainerProps = ComponentProps & {
  fields: GatedAccordionFields;
};

const GatedAccordionContainer = ({
  fields,
  rendering,
}: GatedAccordionContainerProps): JSX.Element => {
  const [error, setError] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleCheck = () => {
    setError(false);
    setIsChecked(!isChecked);
  };

  const handleClickEvent = useCallback(
    (event: MouseEvent) => {
      const alertText = document.getElementById('alertText');
      const confirmationCheckbox = document.getElementById('confirmCheckbox');
      setError(false);

      if (!isChecked) {
        event.preventDefault();
        alertText?.scrollIntoView({ block: 'center' });
        confirmationCheckbox?.focus();
        setError(true);
      }
    },
    [isChecked]
  );

  useEffect(() => {
    eventBus.on('click-event', handleClickEvent);

    return () => eventBus.off('click-event', handleClickEvent);
  }, [handleClickEvent]);

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-8">
            <div id="alertText" className="alert alert--error p-1 py-1">
              {error && (
                <h2 className="sr-only" aria-live="assertive" role="alert">
                  {fields.checkboxHint.value}
                </h2>
              )}
              <div className="d-flex gap-1">
                <div className="flex-shrink-0 icon-wrapper icon-wrapper--size-4">
                  <i className="bi bi-exclamation-triangle" aria-hidden="true" />
                </div>
                <div className="field-text align-self-center">{fields.notificationTitle.value}</div>
              </div>
              <div className="body-default ps-3 mt-2">
                <RichText field={fields.notificationText} />

                <Checkbox
                  id="confirmCheckbox"
                  className="mt-2 mb-3"
                  aria-checked={isChecked}
                  aria-required="true"
                  tabIndex={0}
                  label={fields.checkboxText.value}
                  onChange={handleCheck}
                />
                {error && (
                  <p className="field-error-text text-error-400 mb-3">
                    {fields.checkboxHint.value}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Placeholder rendering={rendering} name="abrdn-gated-accordion-container" hideTitle={true} />
    </>
  );
};

export default withDatasourceCheck()<GatedAccordionContainerProps>(GatedAccordionContainer);
